import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconOpenSidebar: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.62464 12.0843V7.91435C9.62464 7.74129 9.54797 7.62275 9.39464 7.55872C9.24144 7.49456 9.10339 7.52393 8.98047 7.64685L7.15526 9.47206C7.00457 9.62275 6.92922 9.79852 6.92922 9.99935C6.92922 10.2002 7.00457 10.3759 7.15526 10.5266L8.98047 12.3518C9.10339 12.4748 9.24144 12.5041 9.39464 12.44C9.54797 12.3759 9.62464 12.2574 9.62464 12.0843ZM4.42443 17.0827C4.00887 17.0827 3.65387 16.9355 3.35943 16.6412C3.06512 16.3468 2.91797 15.9918 2.91797 15.5762V4.42247C2.91797 4.00692 3.06512 3.65192 3.35943 3.35747C3.65387 3.06317 4.00887 2.91602 4.42443 2.91602H15.5782C15.9937 2.91602 16.3487 3.06317 16.6432 3.35747C16.9375 3.65192 17.0846 4.00692 17.0846 4.42247V15.5762C17.0846 15.9918 16.9375 16.3468 16.6432 16.6412C16.3487 16.9355 15.9937 17.0827 15.5782 17.0827H4.42443ZM13.3346 15.8327H15.8346V4.42247C15.8346 4.35831 15.8079 4.29956 15.7544 4.24622C15.7011 4.19275 15.6423 4.16602 15.5782 4.16602H13.3346V15.8327ZM12.0846 15.8327V4.16602H4.42443C4.36026 4.16602 4.30151 4.19275 4.24818 4.24622C4.19471 4.29956 4.16797 4.35831 4.16797 4.42247V15.5762C4.16797 15.6404 4.19471 15.6991 4.24818 15.7525C4.30151 15.8059 4.36026 15.8327 4.42443 15.8327H12.0846Z"
        fill={color}
      />
    </svg>
  );
};

export default IconOpenSidebar;
